<template>
  <div class="main">
    <div class="body">
      <div class="border">
        <div class="title">后记</div>
        <td>
          <strong>亲爱的同学：</strong><br><br>
          专业报告的排序算法中，内在性格因素权重更高，因为和兴趣相比，内在个性对人一生的影响更加长久和稳固。影响排序算法的因素包括人格、兴趣和职业锚点等多种因素。比如有些理科的同学内在性格特质是强NF（直觉+情感），这种内因决定的和他的表面理科科目兴趣可能有一定背离（为了学好某科目，兴趣是最好的老师。所以某些“兴趣”可能是“培养”而成的兴趣。这种由应试而发的“兴趣”往往是存在一定扭曲和失真的）。<br>

          <br>
          专业选择是一个复杂的过程，也是一个人成长的过程中，极为关键的一步。到底选什么专业好？归根结底，我们选择的专业自己必须喜欢，须能发挥自己的天赋和优势才行。希望报告能为你的选择提供有价值的参考线索。<br>
          <br>
        </td>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  
  
  
};
</script>


<style scoped lang='less'>

.content {
  max-width: 800px;
  margin: 0 auto;
}
.main {
  letter-spacing: 1px;
  .home_page {
    background-image: linear-gradient(#8950d5, #bb85e7);
    color: white;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .body {
    padding: 20px;
  }
  .border {
    padding: 20px;
    padding-bottom: 40px;
    border: 1px solid #c4a7e9;
    position: relative;
    margin-top: 57px;
    .title {
      position: absolute;
      top: -23px;
      left: 276px;
      height: 41px;
      width: 200px;
      background: #c4a7e9;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }

  .tables {
    border: 1px solid #c4a7e9;
  }

  .line div {
    padding: 6px;
    font-weight: bold;
    background-color: #ffffff;
  }
  .l {
    float: left;
  }
  .r {
    float: right;
    margin-bottom: 0px;
  }
}
.n_title {
  display: inline-block;
  text-indent: 2rem;
  position: relative;
  left: -21px;
  background: #c4a7e9;
  color: white;
  margin-top: 90px;
  margin-bottom: 20px;
  width: 300px;
}
.right {
  display: inline-block;
  width: 400px;
  span {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
}
.txt {
  line-height: 30px;
}
#chart {
  width: 500px;
  height: 500px;
  margin: 100px auto 0;
}
.tables1 {
  margin-top: 10px;
  border-collapse: collapse;
  td {
    border: 1px solid rgb(173, 169, 169);
  }
}
.print {
  position: fixed;
  bottom: 100px;
  right: 200px;
}
</style>
